<script lang="ts">import { t, Verbiage } from "@infinitro/content";
import { activeTooltip, displayInFiat, isMobile } from "@infinitro/global";
import { Currency, FiatCurrency } from "@infinitro/global/wallet";
import { CurrencyIcon } from "@infinitro/icons";
import { Text } from "@infinitro/text";
import { onMount } from "svelte";
import { fade } from "svelte/transition";
export let text;
export let currency = FiatCurrency.USD;
export let textColor = "white";
let visible = false;
let triggerElement;
let tooltipElement;
let style = "";
$: textColor;
function toggle() {
	activeTooltip.set(triggerElement);
	visible = !visible;
	console.log("Toggle tooltip", visible);
	if (visible && triggerElement) {
		const rect = triggerElement.getBoundingClientRect();
		style = `top: ${rect.bottom + window.scrollY + 8}px; left: ${rect.left + window.scrollX - 30}px;`;
	}
}
function hide() {
	visible = false;
	activeTooltip.set(null);
	console.log("Hide tooltip", visible, $activeTooltip);
}
function handleScroll() {
	if (!visible) return;
	hide();
	console.log("Handle scroll, hiding tooltip");
}
function getLines(text) {
	return (typeof text === "string" ? text : $t(text)).split("\n");
}
onMount(() => {
	window.addEventListener("scroll", handleScroll, true);
	const unsubscribe = activeTooltip.subscribe((el) => {
		if (!el) return;
		if (el !== triggerElement) visible = false;
		console.log("Active tooltip changed", el, triggerElement, visible);
	});
	return () => {
		window.removeEventListener("scroll", handleScroll, true);
		unsubscribe();
	};
});
</script>

<div class="tooltip-wrapper">
	<!-- svelte-ignore a11y-click-events-have-key-events -->
	<!-- svelte-ignore a11y-no-static-element-interactions -->
	<span
		class="tooltip-trigger"
		bind:this={triggerElement}
		on:click={toggle}
		on:mouseenter={() => (!$isMobile ? (visible = true) : null)}
		on:mouseleave={() => (!$isMobile ? (visible = false) : null)}
	>
		<slot />
	</span>

	{#if visible}
		<button
			class="tooltip-container"
			bind:this={tooltipElement}
			{style}
			transition:fade={{ duration: 150 }}
			on:click={hide}
		>
			{#each getLines(typeof text === 'string' ? text : $t(text)) as line}
				<p class="tooltip-line">
					<Text {textColor} bodyWeight="bold">{line}</Text>
					{#if !$displayInFiat}
						<CurrencyIcon {currency} size={$isMobile ? '16' : '25'} />
					{/if}
				</p>
			{/each}
		</button>
	{/if}
</div>

<style>
	.tooltip-wrapper {
		display: inline-block;
	}

	.tooltip-trigger {
		position: relative;
		z-index: 10;
		cursor: pointer;
}

	.tooltip-container {
		position: fixed;
		z-index: 9999;
		width: auto;
		max-width: 110px;
		border-radius: 0.5rem;
		background-color: var(--color-background-100);
		padding: 0.75rem;
		--tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
		--tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
		box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
		border: 1px solid rgba(255, 255, 255, 0.1);
}

	.tooltip-line {
		margin: 0px;
		display: flex;
		align-items: center;
		gap: 0.5rem;
		font-size: 0.875rem;
		line-height: 1.25rem;
		font-weight: var(--font-main);
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
</style>
